module.exports = __webpack_public_path__ + "static/img/RO.529d0eb3.png";